const STORE_DOMAIN = import.meta.env.VITE_RISKIFIED_SHOP_DOMAIN;

export class RiskifiedService {
  public static init(ssId: string): void {
    const url = `${window.location.protocol}//beacon.riskified.com?shop=${STORE_DOMAIN}&sid=${ssId}`;

    if (!document.querySelector(`script[src="${url}"]`)) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = url;

      document.head.appendChild(script);
    }
  }
}
